module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_library.js
// module id = 81
// module chunks = 0